module.exports = __webpack_public_path__ + "static/img/102.6f39b0c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kittens/200818/102.jpg
// module id = nA89
// module chunks = 0